import React from 'react';
import { Table } from 'antd';
import { currency } from '../formatNumber';

export default class Columns5 extends React.Component {
  constructor(props) {
    super(props);
    this.columns = [
      {
        title: "费用名称",
        dataIndex: "key",
        align: "center",
        width: '33%'
      },
      {
        title: "费用(元/柜)",
        dataIndex: "value",
        align: "center",
        width: '33%',
        render: text => currency(text)
      },
      {
        title: "单位成本(元/箱)",
        dataIndex: "norms",
        align: "center",
        width: '34%',
        render: (text, record) => {
          const { value = 0, norms } = record;
          return currency(value / norms) || '-';
        }
      },
    ];

    this.state = {
      dataSource: [],
      count: 2,
      addressVisible: false,
      id: ''
    };
  }
  componentDidMount() {
    const { list } = this.props;
    this.setState({ dataSource: list || [] });
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  handleSave = row => {
    const newData = [...this.state.dataSource];
    const index = newData.findIndex(item => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    this.setState({ dataSource: newData });
  };


  render() {
    const { dataSource } = this.state;
    const finallySource = dataSource.map((item, index) => ({ ...item, currentId: index }));


    return (
      <>
        <Table
          dataSource={finallySource}
          columns={this.columns}
          rowKey='currentId'
          pagination={false}
          style={{ paddingBottom: '10px' }}
        />
      </>
    );
  }
}
